import { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { useState } from "react";
import BASE_URL from "../BASEURL";
// ContactForm component (top-level)
function ContactForm() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${BASE_URL}/api/inquiry`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("Failed to submit inquiry");
      alert("Enquiry submitted successfully!");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      setError(err.message || "Failed to submit inquiry");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="space-y-5" onSubmit={handleSubmit}>
      {error && <p className="text-red-500 mb-2">{error}</p>}
      <input
        type="text"
        name="name"
        placeholder="Your Name"
        className="w-full border border-gray-300 px-4 py-3 rounded focus:outline-none focus:ring-2 focus:ring-primary"
        value={form.name}
        onChange={handleChange}
        required
      />
      <input
        type="email"
        name="email"
        placeholder="Your Email"
        className="w-full border border-gray-300 px-4 py-3 rounded focus:outline-none focus:ring-2 focus:ring-primary"
        value={form.email}
        onChange={handleChange}
        required
      />
      <input
        type="tel"
        name="phone"
        placeholder="Your Phone Number"
        className="w-full border border-gray-300 px-4 py-3 rounded focus:outline-none focus:ring-2 focus:ring-primary"
        value={form.phone}
        onChange={handleChange}
        required
      />
      <textarea
        rows="4"
        name="message"
        placeholder="Your Message"
        className="w-full border border-gray-300 px-4 py-3 rounded focus:outline-none focus:ring-2 focus:ring-primary"
        value={form.message}
        onChange={handleChange}
        required
      ></textarea>
      <button
        type="submit"
        className="bg-primary text-dark px-6 py-3 rounded font-heading font-semibold hover:bg-primaryLight transition w-full"
        disabled={loading}
      >
        {loading ? "Submitting..." : "Submit Enquiry"}
      </button>
    </form>
  );
}

export default function Contact() {
  // Example: Fetch contact data by ID
  // Replace this with your actual usage or move to a relevant component if needed
  const [contactData, setContactData] = useState(null);
  const [contactLoading, setContactLoading] = useState(false);
  const [contactError, setContactError] = useState("");

  useEffect(() => {
    async function fetchContact() {
      setContactLoading(true);
      setContactError("");
      try {
        const res = await fetch(`${BASE_URL}/api/contact/698e119cda7424c56bcc7b09`);
        if (!res.ok) throw new Error("Failed to fetch contact data");
        const result = await res.json();
        // API returns { message, contact }
        setContactData(result.contact || result);
      } catch (err) {
        setContactError(err.message || "Failed to fetch contact data");
      } finally {
        setContactLoading(false);
      }
    }
    fetchContact();
  }, []);

  // If the page is loaded with #get-in-touch or #contact-form, scroll down responsively
  useEffect(() => {
    if (typeof window === "undefined") return;
    const hash = window.location.hash;
    if (hash === "#get-in-touch" || hash === "#contact-form") {
      setTimeout(() => {
        const elementId = hash === "#get-in-touch" ? "get-in-touch" : "contact-form";
        const element = document.getElementById(elementId);
        if (element) {
          const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
          const isMobile = window.innerWidth < 768;
          const offset = isMobile ? 145 : 125;
          window.scrollTo({ top: elementTop - offset, behavior: "smooth" });
        }
      }, 200);
    }
  }, []);
  return (
    <>
      <Navbar />

      <div className='bg-dark'>
        <Breadcrumb />
      </div>

      {/* BRANCH LOCATIONS */}
      <section className="py-10  ">
        <div className="max-w-7xl mx-auto px-6">

          <div
            className="text-center mb-8"
            data-aos="fade-up"
          >
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-primary">
              Contact Sera Water
            </h1>
            <p className="mt-4 text-gray-600 font-body max-w-3xl mx-auto">
              Get in touch with Sera Water for reliable water and wastewater
              treatment solutions. We serve clients across Ahmedabad and Gujarat
              with complete ETP, STP and WTP equipment.
            </p>
          </div>

          {/* BRANCH GRID */}
          

        </div>
      </section>


      {/* CONTACT + FORM */}
      <section className="py-8 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">

            {/* LEFT CTA - Dynamic Contact Data Only */}
            <div data-aos="fade-right">
              

              <div className="space-y-6">

                {/* Phone */}
                <a
                  href="tel:7575804585"
                  className="flex items-center gap-4 bg-white p-5 rounded-xl shadow-sm hover:shadow-lg transition"
                >
                  <FontAwesomeIcon icon={faPhone} className="text-primary text-xl" />
                  <div>
                    <p className="font-heading font-semibold text-darkGray">Call Us</p>
                    <p className="text-gray-600 text-sm">7575804585</p>
                  </div>
                </a>

                {/* Email */}
                <a
                  href="mailto:serawater007@gmail.com"
                  className="flex items-center gap-4 bg-white p-5 rounded-xl shadow-sm hover:shadow-lg transition"
                >
                  <FontAwesomeIcon icon={faEnvelope} className="text-primary text-xl" />
                  <div>
                    <p className="font-heading font-semibold text-darkGray">Email Us</p>
                    <p className="text-gray-600 text-sm">serawater007@gmail.com</p>
                  </div>
                </a>

                {/* Address */}
                <div className="flex items-center gap-4 bg-white p-5 rounded-xl shadow-sm">
                  <FontAwesomeIcon icon={faLocationDot} className="text-primary text-xl" />
                  <div>
                    <p className="font-heading font-semibold text-darkGray">
                      Head Office
                    </p>
                    <p className="text-gray-600 text-sm">
                      Shed No. 53, Ambica Industrial Estate, Near Vatva Over Bridge, Vatva,
                      Ahmedabad, Gujarat - 382445, India
                    </p>
                  </div>
                </div>



              </div>
            </div>

            {/* RIGHT FORM */}
            <div
              id="get-in-touch" data-aos="fade-left"
              className="bg-white p-8 rounded-2xl shadow-lg"
            >
              <h3 className="text-xl font-heading font-semibold text-darkGray mb-6">
                Send Us a Message
              </h3>
              <ContactForm />
            </div>


          </div>
        </div>
      </section>

      {/* GOOGLE MAP */}
      {/* <section className="w-full h-[450px]" data-aos="fade-up">
        <iframe
          title="Sera Water Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.6512255541593!2d72.62349751053054!3d22.963068479128875!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e89b7d84262fb%3A0x47b0efc341b584f8!2sSera%20Water!5e0!3m2!1sen!2sin!4v1766657055991!5m2!1sen!2sin"
          className="w-full h-full border-0"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </section> */}
      <Footer />
    </>
  );
}
